import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/embr/assets/images/create-auction.svg'


_pushScopeId("data-v-9b3657c4")
const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "-ml-4"
  })
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Save Project Details ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "px-4" }, " Edit ", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Save Auction Configuration ")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "px-4" }, " Edit ", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LgeCreateMultisigWarning = _resolveComponent("LgeCreateMultisigWarning")!
  const _component_LbpProjectDetailInputs = _resolveComponent("LbpProjectDetailInputs")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_LbpProjectDetailReview = _resolveComponent("LbpProjectDetailReview")!
  const _component_StepContainer = _resolveComponent("StepContainer")!
  const _component_LbpAuctionConfigurationInputs = _resolveComponent("LbpAuctionConfigurationInputs")!
  const _component_LbpAuctionConfigurationReview = _resolveComponent("LbpAuctionConfigurationReview")!
  const _component_LbpCreateActions = _resolveComponent("LbpCreateActions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_LgeCreateMultisigWarning),
    _createVNode(_component_StepContainer, {
      complete: _ctx.projectDetailsSaved,
      title: "Enter Your Project Details",
      "step-number": "1"
    }, _createSlots({
      content: _withCtx(() => [
        (!_ctx.projectDetailsSaved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_LbpProjectDetailInputs),
              _createVNode(_component_BalBtn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveProjectDetails())),
                disabled: !_ctx.projectDetailsValid,
                size: "md",
                block: true,
                class: "mt-8 mb-2",
                loading: _ctx.loadingToken,
                "loading-label": "Loading token..."
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]))
          : (_openBlock(), _createBlock(_component_LbpProjectDetailReview, { key: 1 }))
      ]),
      _: 2
    }, [
      (_ctx.projectDetailsSaved)
        ? {
            name: "right",
            fn: _withCtx(() => [
              (_ctx.poolId === null)
                ? (_openBlock(), _createBlock(_component_BalBtn, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editProjectDetails())),
                    size: "sm",
                    disabled: _ctx.creatingLge
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1032, ["complete"]),
    _createVNode(_component_StepContainer, {
      complete: _ctx.lgeConfigSaved,
      title: "Configure Your Liquidity Bootstrapping Pool",
      "step-number": "2"
    }, _createSlots({ _: 2 }, [
      (_ctx.lgeConfigOpen || _ctx.lgeConfigSaved)
        ? {
            name: "content",
            fn: _withCtx(() => [
              (_ctx.lgeConfigOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_LbpAuctionConfigurationInputs),
                    _createVNode(_component_BalBtn, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveLgeConfig())),
                      disabled: !_ctx.lgeConfigValid,
                      size: "md",
                      block: true,
                      class: "mt-8 mb-2"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_LbpAuctionConfigurationReview)
                  ]))
            ])
          }
        : undefined,
      (_ctx.lgeConfigSaved)
        ? {
            name: "right",
            fn: _withCtx(() => [
              (_ctx.poolId === null)
                ? (_openBlock(), _createBlock(_component_BalBtn, {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editLgeConfig())),
                    size: "sm",
                    disabled: !_ctx.projectDetailsSaved || _ctx.creatingLge
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1032, ["complete"]),
    _createVNode(_component_StepContainer, {
      complete: _ctx.lgeSaved,
      title: "Create Your Liquidity Bootstrapping Pool",
      "step-number": "3"
    }, _createSlots({ _: 2 }, [
      (_ctx.reviewAndDeployOpen)
        ? {
            name: "content",
            fn: _withCtx(() => [
              _createVNode(_component_LbpCreateActions)
            ])
          }
        : undefined
    ]), 1032, ["complete"])
  ]))
}